import { Observable } from 'rxjs';
import {GoogleAdsAccount, Integration} from '../../models/integration';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDao } from './BaseDao';
import { DataDestination } from '../../models/dataDestination';

export class IntegrationDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.INTEGRATION, apiHelper);
  }

  getGoogleAdsSubAccounts(integrationId: string, customerId: string, loginCustomerId?: string): Observable<Array<GoogleAdsAccount>> {
    let url = this.apiHelper.getServiceName() + this.getResource()
      + `/google_ads/accounts?integrationId=${integrationId}&customerId=${customerId}`;
    if(loginCustomerId) {
      url += `&loginCustomerId=${loginCustomerId}`;
    }
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }
}
